import {
  closingApi,
  closingDocumentsApi,
  closingInfoApi,
  fundingInformationApi,
  postClosingApi,
  wireInstructionConfirmationApi,
} from 'app/services/api';
import _ from 'lodash';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CLOSING_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/closing`,
  {
    GET_CLOSING_INFO: 'GET_CLOSING_INFO',
    EDIT_CLOSING_INFORMATION: 'EDIT_CLOSING_INFORMATION',
    EDIT_CLOSING_COMPANY: 'EDIT_CLOSING_COMPANY',
    DELETE_CLOSING_COMPANY: 'DELETE_CLOSING_COMPANY',
    GET_CLOSING_DOCUMENTS: 'GET_CLOSING_DOCUMENTS',
    GET_CLOSING_AMORTIZATION_SCHEDULE: 'GET_CLOSING_AMORTIZATION_SCHEDULE',
    GET_FUNDING_INFORMATION: 'GET_FUNDING_INFORMATION',
    EDIT_FUNDING_INFORMATION: 'EDIT_FUNDING_INFORMATION',
    GET_POST_CLOSING: 'GET_POST_CLOSING',
    EDIT_POST_CLOSING: 'EDIT_POST_CLOSING',
    GET_WIRE_INSTRUCTION_CONFIRMATION: 'GET_WIRE_INSTRUCTION_CONFIRMATION',
  },
);

export const getClosingInfoAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await closingInfoApi.getLoanClosingInfo(params);

  return dispatch({
    type: CLOSING_ACTION_TYPE.GET_CLOSING_INFO,
    payload: data,
  });
});

export const clearClosingAmortizationScheduleAction = () => ({
  type: CLOSING_ACTION_TYPE.GET_CLOSING_AMORTIZATION_SCHEDULE,
  payload: {},
});

export const getClosingAmortizationScheduleAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await closingApi.getLoanClosingAmortizationSchedule(params);

    return dispatch({
      type: CLOSING_ACTION_TYPE.GET_CLOSING_AMORTIZATION_SCHEDULE,
      payload: data,
    });
  },
);

export const editClosingInformationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await closingApi.editLoanClosingInfoByApplicationId(params);

  return dispatch({
    type: CLOSING_ACTION_TYPE.EDIT_CLOSING_INFORMATION,
    payload: data,
  });
});

export const editClosingCompanyDataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await closingApi.editLoanClosingCompanyByApplicationId(params);

  return dispatch({
    type: CLOSING_ACTION_TYPE.EDIT_CLOSING_COMPANY,
    payload: data,
  });
});

export const getClosingDocumentsAction = catchAsyncActionError(
  ({ loanId, companyId }) =>
    async dispatch => {
      const { data } = await closingDocumentsApi.getClosingDocuments({ loanId, companyId });

      const sortedDocuments = _.orderBy(
        data?.additionalDocuments,
        ({ name }) => name?.toLowerCase(),
        'asc',
      );

      return dispatch({
        type: CLOSING_ACTION_TYPE.GET_CLOSING_DOCUMENTS,
        payload: sortedDocuments,
      });
    },
);

export const editFundingInformationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await fundingInformationApi.editFundingInformation(params);

  return dispatch({
    type: CLOSING_ACTION_TYPE.EDIT_FUNDING_INFORMATION,
    payload: data,
  });
});

export const getPostClosingAction = catchAsyncActionError(({ loanId }) => async dispatch => {
  const { data } = await postClosingApi.getPostClosing({ loanId });

  return dispatch({
    type: CLOSING_ACTION_TYPE.GET_POST_CLOSING,
    payload: data,
  });
});

export const editPostClosingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await postClosingApi.editPostClosing(params);

  return dispatch({
    type: CLOSING_ACTION_TYPE.EDIT_POST_CLOSING,
    payload: data,
  });
});

export const getWireInstructionConfirmationAction = catchAsyncActionError(
  ({ loanId }) =>
    async dispatch => {
      const { data } = await wireInstructionConfirmationApi.getWireInstructionConfirmation({
        loanId,
      });

      return dispatch({
        type: CLOSING_ACTION_TYPE.GET_WIRE_INSTRUCTION_CONFIRMATION,
        payload: data,
      });
    },
);
